/**
 * Stabile Reaction-Keys (Server-Enum) → Client-Darstellung.
 */

export const CLUB_REACTION_KEYS = [
  "agree",
  "heart",
  "celebrate",
  "hedgehog",
  "sad",
  "angry",
] as const;

export type ClubReactionKey = (typeof CLUB_REACTION_KEYS)[number];

export type ClubReactionDisplay = {
  key: ClubReactionKey;
  emoji: string;
  label: string;
};

const DISPLAY: Record<ClubReactionKey, { emoji: string; label: string }> = {
  agree: { emoji: "👍", label: "Zustimmung" },
  heart: { emoji: "❤️", label: "Herz" },
  celebrate: { emoji: "🎉", label: "Prima" },
  hedgehog: { emoji: "🦔", label: "Igelig" },
  sad: { emoji: "😢", label: "Schade" },
  angry: { emoji: "😠", label: "Ärgerlich" },
};

export function isClubReactionKey(value: string): value is ClubReactionKey {
  return (CLUB_REACTION_KEYS as readonly string[]).includes(value);
}

export function clubReactionDisplay(key: string): ClubReactionDisplay {
  if (isClubReactionKey(key)) {
    return { key, ...DISPLAY[key] };
  }
  return { key: "agree", emoji: "·", label: key || "Unbekannt" };
}

export function allClubReactions(): ClubReactionDisplay[] {
  return CLUB_REACTION_KEYS.map((key) => ({ key, ...DISPLAY[key] }));
}
